import axios from "axios";
import {WorklogsEntry} from "@/model/Worklogs";
import {SpringPagedResult} from "@/service/PagedResult";

const PATH = "/v2/worklogs";
// The largest page size the endpoint accepts
const PAGE_SIZE = 100;

class WorklogServiceV2 {

  /**
   * Gets all open worklogs, ordered by day and start time, loading every page of the paged endpoint.
   */
  getOpenWorklogs(): Promise<Array<WorklogsEntry>> {
    return this.getOpenWorklogsFrom(0, []);
  }

  private getOpenWorklogsFrom(page: number, worklogs: Array<WorklogsEntry>): Promise<Array<WorklogsEntry>> {
    return axios.get<SpringPagedResult<WorklogsEntry>>(PATH, {
      params: {
        status: "OPEN",
        page: page,
        size: PAGE_SIZE
      }
    }).then(response => {
      const loaded = worklogs.concat(response.data.content);
      return page + 1 < response.data.page.totalPages
        ? this.getOpenWorklogsFrom(page + 1, loaded)
        : loaded;
    });
  }
}

export default new WorklogServiceV2();
